import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  refreshKey: 0,
  profileRefreshKey: 0,
  notificationRefreshKey: 0,
  cartRefreshKey: 0,
  offerRefreshKey: 0,
  listRefreshKey: 0,
};

const cartRefreshSlice = createSlice({
  name: "cartRefresh",
  initialState: initialState,
  reducers: {
    triggerRefresh: (state) => {
      state.refreshKey++;
    },
    profileRefresh: (state) => {
      state.profileRefreshKey++;
    },
    notificationRefresh: (state) => {
      state.notificationRefreshKey++;
    },
    cartRefresh: (state) => {
      state.cartRefreshKey++;
    },
    offerRefresh: (state) => {
      state.offerRefreshKey++;
    },
    listRefresh: (state) => {
      state.listRefreshKey++;
    },
    resetCartState: () => initialState,
  },
});

export const {
  triggerRefresh,
  profileRefresh,
  resetCartState,
  notificationRefresh,
  cartRefresh,
  offerRefresh,
  listRefresh,
} = cartRefreshSlice.actions;
export default cartRefreshSlice.reducer;
